import { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export function VerifyEmailBanner() {
  const { user } = useAuth();
  const { t, lang } = useI18n();
  const [sending, setSending] = useState(false);
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/send-verification", { lang });
      toast.success(t("auth.resent"));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setSending(false); }
  };

  return (
    <div className="border-b border-warning/30 bg-warning/10 px-4 py-2 text-sm" data-testid="verify-email-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <MailWarning className="h-4 w-4 text-warning" />
        <span>{t("auth.verifyBanner")} <b>{user.email}</b>.</span>
        <button data-testid="resend-verification-btn" onClick={resend} disabled={sending}
          className="inline-flex items-center gap-1 rounded-full border border-warning/40 px-3 py-0.5 text-xs font-600 transition-colors hover:bg-warning/20 disabled:opacity-60">
          {sending && <Loader2 className="h-3 w-3 animate-spin" />} {t("auth.resend")}
        </button>
      </div>
    </div>
  );
}
